import type { JSX } from 'preact';

export default function RangeValue() {
  return <span className="range-value" aria-hidden={true} />;
}

export function setRangeCustomProperties(e: JSX.TargetedEvent<HTMLInputElement, InputEvent>) {
  const { currentTarget } = e;
  const { parentElement } = currentTarget;

  const value = parseFloat(currentTarget.value);
  const max = currentTarget.max ? parseFloat(currentTarget.max) : 100;
  const min = currentTarget.min ? parseFloat(currentTarget.min) : 0;
  const percent = ((value - min) * 100) / (max - min);
  const ratio = (value - min) / (max - min);
  const { tooltipValue } = currentTarget.dataset;

  parentElement.style.setProperty('--value', `'${tooltipValue || value}'`);
  parentElement.style.setProperty('--ratio', `${ratio}`);
  parentElement.style.setProperty('--percent', `${percent}%`);
}
